export enum TenantActionType {
  GET_TENANTS_LIST_REQUEST = 'GET_TENANTS_LIST_REQUEST',
  GET_TENANTS_LIST_SUCCESS = 'GET_TENANTS_LIST_SUCCESS',
  GET_TENANTS_LIST_FAIL = 'GET_TENANTS_LIST_FAIL',

  GET_TENANT_PROPERTIES_LIST_REQUEST = 'GET_TENANT_PROPERTIES_LIST_REQUEST',
  GET_TENANT_PROPERTIES_LIST_SUCCESS = 'GET_TENANT_PROPERTIES_LIST_SUCCESS',
  GET_TENANT_PROPERTIES_LIST_FAIL = 'GET_TENANT_PROPERTIES_LIST_FAIL',

  GET_SCHEMA_PROPERTY_REQUEST= 'GET_SCHEMA_PROPERTY_REQUEST',
  GET_SCHEMA_PROPERTY_SUCCESS = 'GET_SCHEMA_PROPERTY_SUCCESS',
  GET_SCHEMA_PROPERTY_FAIL = 'GET_SCHEMA_PROPERTY_FAIL',

  SCHEMA_CONFIG_SAVE_REQUEST = 'SCHEMA_CONFIG_SAVE_REQUEST',
  SCHEMA_CONFIG_SAVE_SUCCESS = 'SCHEMA_CONFIG_SAVE_SUCCESS',
  SCHEMA_CONFIG_SAVE_FAIL = 'SCHEMA_CONFIG_SAVE_FAIL',

  SCHEMA_PROPERTY_UPDATE_REQUEST = 'SCHEMA_PROPERTY_UPDATE_REQUEST',
  SCHEMA_PROPERTY_UPDATE_SUCCESS = 'SCHEMA_PROPERTY_UPDATE_SUCCESS',
  SCHEMA_PROPERTY_UPDATE_FAIL = 'SCHEMA_PROPERTY_UPDATE_FAIL',

  GET_TENANT_RULES_REQUEST = 'GET_TENANT_RULES_REQUEST',
  GET_TENANT_RULES_SUCCESS = 'GET_TENANT_RULES_SUCCESS',
  GET_TENANT_RULES_FAIL = 'GET_TENANT_RULES_FAIL',

  GET_TENANT_RULES_SCHEMA_REQUEST = 'GET_TENANT_RULES_SCHEMA_REQUEST',
  GET_TENANT_RULES_SCHEMA_SUCCESS = 'GET_TENANT_RULES_SCHEMA_SUCCESS',
  GET_TENANT_RULES_SCHEMA_FAIL = 'GET_TENANT_RULES_SCHEMA_FAIL',

  GET_RULES_CONFIG_SUCCESS= 'GET_RULES_CONFIG_SUCCESS',

  GET_RULES_FIELDS_REQUEST = 'GET_RULES_FIELDS_REQUEST',
  GET_RULES_FIELDS_SUCCESS = 'GET_RULES_FIELDS_REQUEST',
  GET_RULES_FIELDS_FAIL = 'GET_RULES_FIELDS_FAIL',

  GET_RULES_PSEUDOCODE_REQUEST = 'GET_RULES_PSEUDOCODE_REQUEST',
  GET_RULES_PSEUDOCODE_SUCCESS = 'GET_RULES_PSEUDOCODE_SUCCESS',
  GET_RULES_PSEUDOCODE_FAIL = 'GET_RULES_PSEUDOCODE_FAIL',

  TENANT_RULES_CONFIG_SAVE_REQUEST = 'TENANT_RULES_CONFIG_SAVE_REQUEST',
  TENANT_RULES_CONFIG_SAVE_SUCCESS = 'TENANT_RULES_CONFIG_SAVE_SUCCESS',
  TENANT_RULES_CONFIG_SAVE_FAIL = 'TENANT_RULES_CONFIG_SAVE_FAIL',

  ZONES_SAVE_REQUEST = 'ZONES_SAVE_REQUEST',
  ZONES_SAVE_SUCCESS = 'ZONES_SAVE_SUCCESS',
  ZONES_SAVE_FAIL = 'ZONES_SAVE_FAIL',

  RULES_CONFIG_SAVE_REQUEST = 'RULES_CONFIG_SAVE_REQUEST',
  RULES_CONFIG_SAVE_SUCCESS = 'RULES_CONFIG_SAVE_SUCCESS',
  RULES_CONFIG_SAVE_FAIL = 'RULES_CONFIG_SAVE_FAIL',

  GET_MERMAID_DIAGRAM_REQUEST = 'GET_MERMAID_DIAGRAM_REQUEST',
  GET_MERMAID_DIAGRAM_SUCCESS = 'GET_MERMAID_DIAGRAM_SUCCESS',
  GET_MERMAID_DIAGRAM_FAIL ='GET_MERMAID_DIAGRAM_FAIL',
}
